import { useMemo } from 'react'

import { GroupLearningItem } from '../../models/GroupLearningItem'
import { dummyLearningItem } from '../../models/LearningItem'
import useGroupLearningItems from './useGroupLearningItems'

export default function useGroupLearningItem(groupUuid: string, learningItemUuid: string) {
  const { groupLearningItems, error, isPlaceholderData } = useGroupLearningItems(groupUuid)
  const groupLearningItem = useMemo(() => {
    const item = groupLearningItems.find(({ uuid }) => uuid === learningItemUuid)
    if (!item) {
      if (error) {
        return dummyLearningItem(learningItemUuid, error)
      } else if (isPlaceholderData) {
        return dummyLearningItem(learningItemUuid)
      }
      return dummyLearningItem(learningItemUuid, new Error('Learning item not found'))
    }

    return item
  }, [groupLearningItems, error, isPlaceholderData, learningItemUuid])
  return { groupLearningItem } as { groupLearningItem: GroupLearningItem }
}
